import React from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineAccountBalanceWallet, MdOutlineDomain, MdOutlineWarning, MdCheckCircle, MdOutlineSchool, MdOutlineLocalHospital, MdOutlineSecurity, MdOutlineEmojiTransportation } from 'react-icons/md';
import styles from "./Imposto.module.css";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";

function ImpostoRenda() {
  return (
    <div className={styles.paginaGestao}>    
      <section className={styles.bannerGestao}>
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerConteudo}>
            <h1>Imposto de Renda (IRPF e IRPJ)</h1>
            <p>Assessoria tributária especializada para pessoas físicas e jurídicas. Assegure a conformidade fiscal do seu patrimônio e previna passivos perante a Receita Federal do Brasil.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnCyan}`}>Entre em Contato</Link>
          </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}>         
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Conformidade Tributária</h2>
            <h3 className={styles.subtituloAzul}>Natureza do Tributo e Incidência</h3>
            <p>O Imposto de Renda (IR) é um tributo federal de competência da União, cuja incidência recai sobre a aquisição de disponibilidade econômica ou jurídica de renda e proventos de qualquer natureza.</p>
            <p><strong>Síntese Operacional:</strong> Trata-se da tributação incidente sobre os rendimentos auferidos ao longo do ano-calendário, oriundos de remunerações, lucros, aluguéis ou aplicações financeiras.</p>
            
            <div className={styles.perfisContainer}>
              <div className={styles.perfilCard}>
                <div className={styles.perfilHeader}>
                  <MdOutlineAccountBalanceWallet className={styles.iconePerfil} />
                  <h4>Pessoa Física (IRPF)</h4>
                </div>
                <p>Aplicável a contribuintes pessoas físicas. A apuração fundamenta-se nos rendimentos anuais auferidos e está sujeita à tabela progressiva da Receita Federal, podendo resultar em saldo devedor ou direito à restituição.</p>
              </div>

              <div className={styles.perfilCard}>
                <div className={styles.perfilHeader}>
                  <MdOutlineDomain className={styles.iconePerfil} />
                  <h4>Pessoa Jurídica (IRPJ)</h4>
                </div>
                <p>Incidente sobre pessoas jurídicas. A apuração é processada com base no lucro real, presumido ou arbitrado da corporação, em estrita observância ao regime tributário adotado.</p>
              </div>
            </div>
          </div>
          <div className={styles.imagemWrapper}>
            <img 
              src={img1} 
              alt="Análise de tributos e conformidade fiscal" 
              className={styles.imagemEspaco} 
            />
          </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgClaro}`}>
        <div className={`${styles.containerGrid} ${styles.gridInvertido}`}>
          
          <div className={styles.imagemWrapper}>
            <img 
              src={img2}
              alt="Organização de demonstrativos financeiros e recibos" 
              className={styles.imagemEspaco} 
            />
          </div>

          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Bases de Cálculo</h2>
            <p>A legislação tributária determina rigor na prestação de contas patrimoniais. Compõem a base de cálculo os rendimentos tributáveis, tais como: <strong>remunerações, proventos de aposentadoria, receitas de aluguéis e ganhos de capital sobre investimentos.</strong></p>
            
            <h3 className={styles.subtituloAzul} style={{marginTop: '2rem'}}>A Declaração de Ajuste Anual</h3>
            <p>A Declaração é o instrumento pelo qual o contribuinte consolida suas informações financeiras para auditoria e cruzamento de dados pela Receita Federal do Brasil (RFB).</p>
            
            <ul className={styles.listaImposto}>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Informativo de Rendimentos:</strong> Declaração integral das receitas auferidas durante o exercício fiscal.</span>
              </li>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Evolução Patrimonial:</strong> Apuração pormenorizada de bens móveis, imóveis e saldos mantidos em contas correntes e aplicações financeiras.</span>
              </li>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Despesas Dedutíveis:</strong> Comprovação legal de dispêndios com saúde e educação, visando a mitigação lícita da base de cálculo do tributo.</span>
              </li>
            </ul>

            <div className={styles.boxRestituicao}>
              <strong>Direito à Restituição:</strong> Caso o montante retido na fonte ou recolhido antecipadamente seja superior ao imposto apurado no ajuste anual, o contribuinte fará jus à restituição do saldo excedente.
            </div>
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Riscos e Penalidades</h2>
            <h3 className={styles.subtituloAzul}>Implicações da Omissão Fiscal</h3>
            <p>A inobservância dos prazos de entrega ou a omissão dolosa de informações patrimoniais caracterizam infrações sujeitas a severas sanções administrativas e penais.</p>
            
            <div className={styles.alertaImposto}>
              <MdOutlineWarning className={styles.iconeAlertaVermelho} />
              <div>
                <p><strong>Consequências da Irregularidade Fiscal:</strong></p>
                <p>Aplicação de multas acrescidas de juros de mora (Taxa Selic), suspensão ou irregularidade cadastral no CPF/CNPJ e bloqueios imediatos para operações em instituições financeiras e obtenção de linhas de crédito.</p>
              </div>
            </div>

            <Link to="/contato" className={`${styles.btnLink} ${styles.btnAzul}`} style={{marginTop: '2rem'}}>
              Agendar Avaliação Fiscal
            </Link>
          </div>

          <div className={styles.destinoContainer}>
            <h4 className={styles.tituloDestino}>Destinação dos Recursos</h4>
            <p className={styles.textoDestino}>A arrecadação tributária é destinada ao financiamento de políticas públicas indispensáveis ao desenvolvimento nacional, englobando:</p>
            
            <div className={styles.gridIconesDestino}>
              <div className={styles.destinoItem}>
                <div className={styles.bolaIcone}><MdOutlineLocalHospital /></div>
                <span>Saúde Pública</span>
              </div>
              <div className={styles.destinoItem}>
                <div className={styles.bolaIcone}><MdOutlineSchool /></div>
                <span>Educação</span>
              </div>
              <div className={styles.destinoItem}>
                <div className={styles.bolaIcone}><MdOutlineSecurity /></div>
                <span>Segurança</span>
              </div>
              <div className={styles.destinoItem}>
                <div className={styles.bolaIcone}><MdOutlineEmojiTransportation /></div>
                <span>Infraestrutura</span>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default ImpostoRenda;